export default __webpack_public_path__ + "static/Checklist-d96a0daded45f42cdd683130152f9571.pdf";